export function isPriceDiscount(finalPrice: string, initialPrice?: string) {
  if (!initialPrice) {
    return false;
  }

  return initialPrice !== finalPrice;
}
